var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6650_6056)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.25H23.5V23.75H0V0.25Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1518 14.8465H8.66613L9.59512 9.16534H11.0808L10.1518 14.8465ZM15.5377 9.30488C15.1123 9.1428 14.6607 9.06064 14.2055 9.06253C12.7382 9.06253 11.705 9.83583 11.6984 10.9425C11.6866 11.7577 12.4379 12.2115 13.0004 12.4833C13.5754 12.7616 13.7715 12.943 13.7715 13.1905C13.7649 13.5709 13.3066 13.7464 12.8785 13.7464C12.2851 13.7464 11.9679 13.656 11.4847 13.4445L11.2886 13.3535L11.0808 14.6291C11.4296 14.7855 12.0714 14.925 12.7382 14.9309C14.2973 14.9309 15.3122 14.1694 15.324 12.9914C15.3299 12.3445 14.9333 11.8488 14.077 11.4441C13.5571 11.1841 13.2391 11.0086 13.2391 10.7428C13.245 10.5004 13.5079 10.253 14.0946 10.253C14.4752 10.2421 14.8534 10.3166 15.2013 10.4711L15.3357 10.5313L15.5377 9.30488ZM17.5131 12.8343L18.1058 11.2444C18.0999 11.2568 18.2284 10.9124 18.3011 10.7009L18.4054 11.19C18.4054 11.19 18.6867 12.5501 18.7476 12.8343H17.5131ZM19.3469 9.16534H18.1976C17.8429 9.16534 17.5734 9.26816 17.4206 9.63681L15.2138 14.8465H16.7729L17.085 13.9946H18.9922C19.0355 14.1936 19.1699 14.8465 19.1699 14.8465H20.5454L19.3469 9.16534ZM7.42504 9.16534L5.96951 13.0392L5.81088 12.2534C5.5421 11.3472 4.6983 10.3624 3.75684 9.87255L5.08973 14.8406H6.66129L8.9966 9.16534H7.42504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61848 9.16504H2.22736L2.20312 9.28034C4.06844 9.75107 5.30292 10.8879 5.81038 12.2538L5.29044 9.64238C5.20525 9.2796 4.94234 9.17752 4.61848 9.16504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6650_6056"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.40842c8114b801889049ea06d68f220e.svg";
export { ForwardRef as ReactComponent };